// https://kentcdodds.com/blog/authentication-in-react-applications
// https://github.com/kentcdodds/bookshelf/blob/master/src/context/auth-context.js

import React, { useState } from 'react'

import { getAuthData, tokenStorage } from '../../lib/auth'

const AuthContext = React.createContext()

function AuthProvider(props) {
  const authToken = tokenStorage.getItem()
  const [authData, setAuthData] = useState(getAuthData(authToken))

  const login = (token) => {
    tokenStorage.setItem(token)
    setAuthData(getAuthData(token))
  }

  const logout = () => {
    tokenStorage.removeItem()
    setAuthData({ isAuthenticated: false, user: {}, ability: {} })
  }

  return (
    <AuthContext.Provider value={{ ...authData, login, logout }} {...props} />
  )
}

function useAuth() {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}

export { AuthProvider, useAuth }
